import React, { Component } from "react";
import "./styleSheets/App.css";
import Login from "./components/Login";
import { getUser } from "./utility/preferences";
import Dashboard from "./components/Dashboard";
import EmsDetail from "./components/EmsDetail";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import history from "./utility/history";
import "fontsource-roboto";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: "",
    };
  }

  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              if (getUser() == null) {
                return <Redirect to="/login" />;
              } else {
                return <Redirect to="/dashboard" />;
              }
            }}
          />
          <Route exact path="/login" component={Login} />
          <Route exact path="/dashboard" component={Dashboard} />
          <Route exact path="/EmsDetail" component={EmsDetail} />

          {/* </Route> */}
        </Switch>
      </Router>
    );
  }
}
